import axios from 'axios'
import {checkIsSupportedDocTypeView} from '../../../models/documents/views'

export const DT_VIEWS_SET_LIST = 'DT_VIEWS_SET_LIST'
export const DT_VIEWS_SET_SELECTED = 'DT_VIEWS_SET_SELECTED'
export const DT_VIEWS_SET_IS_LOADING = 'DT_VIEWS_SET_IS_LOADING'
export const DT_VIEWS_FETCH_LIST = 'DT_VIEWS_FETCH_LIST'
export const DT_VIEWS_CREATE = 'DT_VIEWS_CREATE'
export const DT_VIEWS_DELETE = 'DT_VIEWS_DELETE'
export const DT_VIEWS_UPDATE = 'DT_VIEWS_UPDATE'

const state = {
    dtViews: [],
    dtSelectedView: null,
    isLoadingDocTypeViews: false
}

const getters = {
    dtViews: state => state.dtViews || [],
    supportedDocTypeViews: state => state.dtViews.filter(view => checkIsSupportedDocTypeView(view.type)),
    dtSelectedView: state => state.dtSelectedView,
    isLoadingDocTypeViews: state => state.isLoadingDocTypeViews
}

const mutations = {
    [DT_VIEWS_SET_LIST]: (state, data) => {
        state.dtViews = data
    },
    [DT_VIEWS_SET_SELECTED]: (state, data) => {
        state.dtSelectedView = data
    },
    [DT_VIEWS_SET_IS_LOADING]: (state, data) => {
        state.isLoadingDocTypeViews = data
    }
}

const actions = {
    [DT_VIEWS_FETCH_LIST]({commit, getters, rootState}, dtUuid) {
        commit(DT_VIEWS_SET_IS_LOADING, true)
        return axios.get(`documents/types/${dtUuid}/views`, {requestId: dtUuid})
            .then(res => {
                commit(DT_VIEWS_SET_LIST, res.data.data || [])
                if (getters.dtViews.length !== 0) {
                    let view
                    if (rootState.route.query.view) {
                        view = getters.dtViews.find(v => v.uuid === rootState.route.query.view)
                    } else {
                        view = getters.dtViews.find(v => v.isDefault)
                    }
                    commit(DT_VIEWS_SET_SELECTED, view || getters.dtViews[0])
                } else {
                    commit(DT_VIEWS_SET_SELECTED, null)
                }
            })
            .finally(() => {
                commit(DT_VIEWS_SET_IS_LOADING, false)
            })
    },
    [DT_VIEWS_CREATE]({commit, getters}, {dtUuid, data}) {
        return axios.post(`documents/types/${dtUuid}/views`, data)
            .then(res => {
                commit(DT_VIEWS_SET_LIST, getters.dtViews.concat(res.data.data))
                commit(DT_VIEWS_SET_SELECTED, res.data.data)
            })
    },
    [DT_VIEWS_UPDATE]({commit, getters}, {dtUuid, viewUuid, data}) {
        return axios.post(`documents/types/${dtUuid}/views/${viewUuid}`, data, {requestId: viewUuid})
            .then(res => {
                const idx = getters.dtViews.findIndex(v => v.uuid === viewUuid)
                if (idx !== -1) {
                    getters.dtViews.splice(idx, 1, res.data.data)
                }
                if (viewUuid === getters.dtSelectedView.uuid) {
                    commit(DT_VIEWS_SET_SELECTED, res.data.data)
                }
                commit(DT_VIEWS_SET_LIST, getters.dtViews)
            })
    },
    [DT_VIEWS_DELETE]({commit, getters}, {dtUuid, viewUuid}) {
        return axios.delete(`documents/types/${dtUuid}/views/${viewUuid}`)
            .then(() => {
                const idx = getters.dtViews.findIndex(v => v.uuid === viewUuid)
                if (idx !== -1) {
                    getters.dtViews.splice(idx, 1)
                }
                commit(DT_VIEWS_SET_LIST, getters.dtViews)
                if (getters.dtViews.length !== 0) {
                    commit(DT_VIEWS_SET_SELECTED, getters.dtViews[0])
                }
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
